import { uid } from "../../lib/uid";
import { todayIso, fmtDate } from "../../lib/format";

export const CARD_COLS = [
  { key: "company", label: "Firma" },
  { key: "bank", label: "Banka" },
  { key: "card_no", label: "Kart No", type: "text" },
  { key: "statement_date", label: "İşlem Tarihi", type: "date" },
  { key: "line_budget_parent_name", label: "Ana Bütçe", value: (c) => c.line_budget_parent_name || "—" },
  { key: "line_budget_item_name", label: "Alt Bütçe", value: (c) => c.line_budget_item_name || "—" },
  { key: "amount", label: "Tutar", type: "number" },
  { key: "description", label: "Açıklama", type: "text", value: (c) => c.description || "—" },
  { key: "durum", label: "Durum", options: [{ value: "Açık", label: "Açık" }, { value: "Ödendi", label: "Ödendi" }], value: (c) => (c.paid ? "Ödendi" : "Açık") },
];

export const cls = "w-full px-3 py-2 text-sm border border-slate-300 rounded-md bg-white focus:border-amber-500 focus:ring-1 focus:ring-amber-500 outline-none";
export const emptyLine = () => ({ _k: uid(), tx_date: todayIso(), budget_parent_id: "", budget_item_id: "", amount: "", description: "" });
export const emptyCard = { registered_card_id: "", company: "", bank: "", card_no: "", amount: "", statement_date: todayIso(), due_date: "", description: "", line_budget_parent_id: "", line_budget_item_id: "" };
export const emptyRegCard = { company: "", bank: "", card_no: "", holder_name: "", expiry_date: "", statement_day: "", due_day: "" };
export const DAYS_1_31 = Array.from({ length: 31 }, (_, i) => i + 1);

export function L({ label, children }) {
  return (
    <label className="block">
      <span className="block text-[11px] font-semibold text-slate-600 mb-1 uppercase tracking-wide">{label}</span>
      {children}
    </label>
  );
}

// hesap kesim dönemi: backend payment_plan._period_end ile aynı kural
export function periodEnd(card, tx) {
  const d = new Date(tx.slice(0, 10) + "T00:00:00");
  const sd = Number(card.statement_day) || 0;
  let y = d.getFullYear(), m = d.getMonth();
  if (!sd) return new Date(y, m + 1, 0).toISOString().slice(0, 10);
  if (d.getDate() > sd) { m += 1; if (m > 11) { m = 0; y += 1; } }
  const last = new Date(y, m + 1, 0).getDate();
  return `${y}-${String(m + 1).padStart(2, "0")}-${String(Math.min(sd, last)).padStart(2, "0")}`;
}

export const paidLabel = (c) => (c.paid ? `Ödendi${c.paid_at ? ` (${fmtDate(c.paid_at)})` : ""}` : "Ödenmedi");
